import assign from 'object-assign';
import EffectiveRightsType from 'owa-service/lib/contract//EffectiveRightsType';
import getItemIdToUpdate from 'mini-calendar-event-services/lib/utils/getItemIdToUpdate';
import { AllMeetingMessageType } from 'mini-calendar-event-services/lib/schema/AllMeetingMessageType';
import { CalendarEvent } from 'mini-calendar-event-types';
import { calendarEvent } from 'mini-calendar-event-converter';
import { getDetailedCalendarEvent } from 'mini-calendar-event-services/lib/services/getDetailedCalendarEvent';
import { getDisplayDateFromEwsDate } from 'owa-datetime';
import { getEventScope } from 'mini-calendar-event-services/lib/utils/getEventScope';
import { isMeetingCancelled } from './isMeetingCancelled';
import { isRecurringItem } from 'mini-calendar-event-services/lib/utils/isRecurringItem';
import { trace } from 'owa-trace';

const getConflictingEventsPartialEvent = (item: AllMeetingMessageType): Partial<CalendarEvent> =>
    calendarEvent({
        ConflictingMeetings: item.ConflictingMeetings,
        AdjacentMeetings: item.AdjacentMeetings,
    });

const getEffectiveRightsForItem = (item: AllMeetingMessageType): EffectiveRightsType => ({
    Modify: isMeetingCancelled(item) && !item.IsOrganizer,
});

/**
 * Given an item it returns a calendar event
 * @param item
 */
export const convertMailMeetingItemToCalendarEvent = async (
    item: AllMeetingMessageType,
    fetchFullEventFromServer?: boolean
): Promise<CalendarEvent> => {
    let finalMeetingItem: CalendarEvent = calendarEvent({
        ...item,
        IsCancelled: isMeetingCancelled(item),
        IsRecurring: isRecurringItem(item),
        EffectiveRights: getEffectiveRightsForItem(item),
        CharmId: 0,
        IsOrganizer: !!item?.IsOrganizer || item?.ResponseType === 'Organizer',
    });

    if (fetchFullEventFromServer && item.AssociatedCalendarItemId) {
        const scope = getEventScope(item);

        const calendarEventId = {
            mailboxInfo: undefined,
            Id: item.AssociatedCalendarItemId?.Id,
            ...getItemIdToUpdate(item.AssociatedCalendarItemId.Id, scope),
        };

        const options = {
            IncludeDeclinedMeetings: true,
        };

        try {
            finalMeetingItem = await getDetailedCalendarEvent(calendarEventId, options, scope);
        } catch (error) {
            trace.warn(error);
        }
    }

    const { ConflictingMeetings, AdjacentMeetings } = getConflictingEventsPartialEvent(item);

    return assign(
        new CalendarEvent(),
        finalMeetingItem,
        {
            ItemId: item?.AssociatedCalendarItemId,
            AssociatedMailItemId: item?.ItemId,
            ProposedNewTimeStart:
                item.ProposedStart && getDisplayDateFromEwsDate(item.ProposedStart),
            ProposedNewTimeEnd: item.ProposedEnd && getDisplayDateFromEwsDate(item.ProposedEnd),
            ConflictingMeetings,
            AdjacentMeetings,
        } /** mailbox */
    );
};
